module.exports = "./img/f39b18c00172c93f025e00a835fce96d.png";